export class MerchPercentage {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default MerchPercentage;